import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Warranty from "./warranty";
import Consult from "./consult";
import Experience from "./experience";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function BarPro(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <SEOMeta
        title="neat.bar Pro, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat.bar Pro"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, bar Pro, neat bar Pro, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          <span>All-in-One, AI</span> 화상회의 디바이스
        </div>
        <div className={style.device_title}>
          <img
            className={style.big_title}
            src={`${
              process.env.REACT_APP_CLIENT_URL
            }img/device/neat/title_neat_bar_pro${isMobile ? "_m" : ""}.webp`}
            alt="bar"
          />
        </div>
      </div>
      <div className={style.device_text}>
        대형회의실 및 강의실을 위한{isMobile ? <br /> : " "}최적의 화상회의 장비
      </div>

      <div className={style.device_img_list}>
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/barpro_1${
            isMobile ? "_m" : ""
          }.webp`}
          alt="bar"
        />
        <img
          src={`${process.env.REACT_APP_CLIENT_URL}img/device/neat/barpro_2${
            isMobile ? "_m" : ""
          }.webp`}
          alt="bar"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div className={style.device_description_img_box}>
          {isMobile ? (
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                "img/device/neat/barpro_reddot_2024_m.webp"
              }
              alt="bar"
            />
          ) : (
            <>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/device/neat/barpro_device.png"
                }
                alt="bar"
              />
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/device/neat/reddot_2022.webp"
                }
                alt="reddot"
              />
            </>
          )}
          <div className={style.device_description_text_box}>
            Neat Pad (컨트롤러) 포함
          </div>
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/full${isMobile ? "_m" : ""}.webp`
                  }
                  alt="full"
                />
              </div>
              <div className={style.device_description_text}>
                <span>수용인원 10명 이상의</span> 대규모 회의 공간에 이상적
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/focus${isMobile ? "_m" : ""}.webp`
                  }
                  alt="focus"
                />
              </div>
              <div className={style.device_description_text}>
                <span>AI 기반</span> 자동 프레이밍 기능. 참가자를{" "}
                <span>자동으로 추적&포커스</span>
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/3${isMobile ? "_m" : ""}.webp`
                  }
                  alt="3"
                />
              </div>
              <div className={style.device_description_text}>
                <span>3개의</span> 대형 화면을 구동할 수 있어 몰입도 높은 사용자
                경험
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/noise${isMobile ? "_m" : ""}.webp`
                  }
                  alt="noise"
                />
              </div>
              <div className={style.device_description_text}>
                16개의 강력한 마이크 배열이 <span>배경 소음을 제거</span>
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Bar Pro <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_barpro_1${isMobile ? "_m" : ""}.webp`
                }
                alt="feature1"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>대회의실</div>
              </div>
              <div className={style.device_features_text}>
                {`수용인원 10명 이상이 모인 수업이나 대규모 회의 공간에 이상적입니다.\n` +
                  `대형 스크린 3개를 구동할 수 있어, 어느 공간에서나 우수한 품질로 자연스러운${
                    isMobile ? " " : "\n"
                  }` +
                  `회의 경험을 제공합니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {/* <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_barpro_2${isMobile ? "_m" : ""}.webp`
                }
                alt="feature2"
              /> */}
              <video
                autoPlay={true}
                muted={true}
                loop={true}
                controls={false}
                src={`${process.env.REACT_APP_CLIENT_URL}video/feature_barpro_2.mp4`}
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  업그레이드 된 스피커·마이크·카메라
                </div>
              </div>
              <div className={style.device_features_text}>
                {`3개의 풀레인지 스키퍼, 이중 대화/배경 소음 문제를 없애는 명확한 음성 픽업,${
                  isMobile ? " " : "\n"
                }` +
                  `망원/광각 렌즈 및 16배 줌을 제공하는 카메라로${
                    isMobile ? " " : "\n"
                  }` +
                  `대규모 회의 공간에 더욱 이상적입니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_barpro_3${isMobile ? "_m" : ""}.webp`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  간단한 설정
                </div>
              </div>
              <div className={style.device_features_text}>
                {`테이블 위에 놓거나 1,2개 or 3개의 스크린 위/아래/벽면에 장착 가능합니다.\n` +
                  `Neat Pad 컨트롤러의 지침대로 따라가면 Bar Pro가 배치에 맞게 조정되며${
                    isMobile ? " " : "\n"
                  }` +
                  `View가 재정렬 됩니다.`}
                <div className={style.device_features_not_support}>
                  * 3개의 화면은 Microsoft Teams에서 아직 지원되지 않습니다.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={`${
                process.env.REACT_APP_CLIENT_URL
              }img/device/neat/spec_barpro_1${isMobile ? "_m" : ""}.webp`}
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div className={style.device_spec_img_box}>
              <img
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/spec_barpro_2${isMobile ? "_m" : ""}.webp`}
                alt="spec2"
              />
            </div>
            <div className={style.device_spec_img_box}>
              <img
                src={`${
                  process.env.REACT_APP_CLIENT_URL
                }img/device/neat/spec_barpro_3${isMobile ? "_m" : ""}.webp`}
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div className={style.device_spec_text_wrap}>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>자동 감지 센서 (레이더)</span>
                <span>깊이 센서 (VGA 60° FOV)</span>
                <span>방향 센서 (가속도계)</span>
                <span>주변광/온도/습도/공기 품질 센서</span>
                <span>카메라 LED / 시스템 LED</span>
                <span>테이블 스탠드, 벽면 마운트 및 스크린 마운트</span>
                <span>트리플 스크린 지원</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "40px" }}
            >
              <div className={style.device_spec_text_label}>비디오</div>
              <div className={style.device_spec_text}>
                <span>Pro 100MP 듀얼 카메라 시스템</span>
                <span>광각 카메라: 50MP, ƒ/2.8 조리개, 113° 수평 시야각</span>
                <span>망원 카메라: 50MP, ƒ/1.8 조리개, 70° 수평 시야각</span>
                <span>최대 16배 하이브리드 줌</span>
                <span>자동 인물 프레이밍</span>
                <span>인물 비디오 해상도: 최대 1080p/30</span>
                <span>콘텐츠 비디오 해상도: 720p/60 , 1080p/30</span>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "145px" }}
            >
              <div className={style.device_spec_text_label}>오디오</div>
              <div className={style.device_spec_text}>
                <span>풀레인지 스피커 3개</span>
                <span>진동 제거를 위한 양방향 우퍼</span>
                <span>추적마이크 4개</span>
                <span>빔포밍 마이크 16개</span>
                <span>하드웨어 가속 오디오 처리</span>
                <span>에코 제거</span>
                <span>오토 게인 컨트롤</span>
                <span>잔향 제거</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "45px" }}
            >
              <div className={style.device_spec_text_label}>
                네트워크 & 포트
              </div>
              <div className={style.device_spec_text}>
                <span>Wi-Fi</span>
                <span>AC 전원 (내부 전원 공급 장치)</span>
                <span>터치 스크린 연결 시 입력용 USB-C</span>
                <span>이더넷</span>
                <span>외부 화면용 HDMI 출력 3개</span>
                <span>화면 공유용 HDMI 입력</span>
                <span>타사 오디오 확장용 보조 포트(RJ45)</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "87px" }}
            >
              <div className={style.device_spec_text_label}>크기 및 무게</div>
              <div className={style.device_spec_text}>
                <span>너비: 890mm(35.04인치)</span>
                <span>높이: 80mm(3.15인치)</span>
                <span>깊이: 80mm(3.15인치)</span>
                <span>무게: 3.1kg(6.83파운드)</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage: `url('${
              process.env.REACT_APP_CLIENT_URL
            }img/device/neat/spec_barpro_bg${isMobile ? "_m" : ""}.webp')`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>70° to 113°</div>
            <div className={style.device_spec_icon_label}>수평 시야</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>50 MP</div>
            <div className={style.device_spec_icon_label}>캡처 해상도</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>16x</div>
            <div className={style.device_spec_icon_label}>디지털 줌</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.micArray16_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mic_array_16${isMobile ? "_m" : ""}.webp`
                }
                alt="mic16"
              />
            </div>
            <div className={style.device_spec_icon_label}>16 마이크 어레이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.vibration_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/vibration${isMobile ? "_m" : ""}.webp`
                }
                alt="vibration"
              />
            </div>
            <div className={style.device_spec_icon_label}>진동 상쇄 설계</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>3</div>
            <div className={style.device_spec_icon_label}>풀 레인지 스피커</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.tripleScreen_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/triple_screen${isMobile ? "_m" : ""}.webp`
                }
                alt="triplescreen"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              트리플 스크린 지원
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.wifi_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/wifi${isMobile ? "_m" : ""}.webp`
                }
                alt="wifi"
              />
            </div>
            <div className={style.device_spec_icon_label}>와이파이</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>Sensors</div>
            <div className={style.device_spec_icon_label}>
              깊이, 웨이크업, 조명,{isMobile ? <br /> : " "}방향 온도, 습도 및
              공기 질
            </div>
          </div>
        </div>

        <Warranty />
      </div>

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default BarPro;
